import React from "react";
import CouponInput from "./coupon-input";

import "intl";
import "intl/locale-data/jsonp/en.js";

let formatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 2
});

class PromoCode extends React.Component {
    state = {
        showInput: false
    };

    handleLinkClick = e => {
        e.preventDefault();
        this.setState({
            showInput: true
        });
    };

    UNSAFE_componentWillReceiveProps(nextProps) {
        let { coupon } = nextProps;
        if (coupon) {
            if (this.props.coupon) {
                if (this.props.coupon.code == nextProps.coupon.code) {
                    return;
                }
            }
            this.setState({ showInput: false });
        }
    }

    render() {
        if (this.state.showInput) {
            return <CouponInput />;
        }

        let text;
        if (this.props.coupon) {
            let { code, percent_off, amount_off } = this.props.coupon;

            let offText;
            if (percent_off) {
                offText = `${percent_off}%`;
            } else {
                offText = `${formatter.format(amount_off / 100)}`;
            }
            text = `${code}: ${offText} off your NounPro subscription`;
        } else {
            text = "Apply a promotional code";
        }

        return (
            <div className="coupon-value">
                <a href="#" className="icon-link">
                    <span className="ui_discount" />
                </a>
                <a
                    href="#"
                    className="icon-link text-link coupon-name"
                    onClick={this.handleLinkClick}
                >
                    {text}
                </a>
            </div>
        );
    }
}

export default PromoCode;
